export default __webpack_public_path__ + "static/0014-c81b9892008b5277939df6d2971b28f7.png";